import { makeAutoObservable } from "mobx";
import moment from "moment";
import Shipment from "../api/envio/envio";
import { getError } from "../util/util";
import {
  EnumStatusShipment,
  EnumStatusCatalogs,
} from "../../shared/Enumerables";

export class ShipmentStore {
  rootStore;

  constructor(rootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  loading = false;
  entities = [];
  entity = undefined;

  guium = undefined;

  pageSize = 5;
  lastPage = 0;
  currentPage = 0;

  entitiesSearched = undefined;
  clearEntitiesSearched = () => {
    this.entitiesSearched = undefined;
  };

  setCurrentPage = (page) => {
    this.currentPage = page;
  };

  initialUsersFilters = {
    fechaInicio: new Date(),
    fechaFin: new Date(),
    idProovedor: { label: "Todos", value: null },
  };
  filterUsers = {
    fechaInicio: new Date(),
    fechaFin: new Date(),
    idProovedor: { label: "Todos", value: null },
  };
  initialProvidersFilters = {
    fechaInicio: new Date(),
    fechaFin: new Date(),
    idDestino: { label: "Todos", value: null },
  };
  filterProviders = {
    fechaInicio: new Date(),
    fechaFin: new Date(),
    idDestino: { label: "Todos", value: null },
  };
  setFilterUsers = (value) => {
    this.filterUsers = value;
  };
  setFilterProviders = (value) => {
    this.filterProviders = value;
  };

  getAll = async (filter) => {
    this.showLoading();
    try {
      if (filter?.fechaFin) {
        filter.fechaFin = moment(new Date(filter?.fechaFin)).format(
          "yyyy-MM-DDThh:mm:ss"
        );
      }
      if (filter?.fechaInicio) {
        console.log(filter?.fechaInicio);
        filter.fechaInicio = moment(new Date(filter?.fechaInicio)).format(
          "yyyy-MM-DDThh:mm:ss"
        );
      }
      const result = await Shipment.getAll(filter);
      if (result.success) {
        this.entities = result.data.data;
        this.lastPage = result.data.lastPage;
      }
    } catch (error) {
      this.displayError(error);
    } finally {
      this.hideLoading();
    }
  };

  onFilter = (value) => {
    this.entitiesSearched =
      !value && value.length <= 0
        ? undefined
        : this.entities.filter(
            (x) =>
              x.numeroGuia.toLowerCase().indexOf(value.toLowerCase()) !== -1 ||
              x.descripcionEnvio.toLowerCase().indexOf(value.toLowerCase()) !==
                -1 ||
              x.numeroCartaPorte.toLowerCase().indexOf(value.toLowerCase()) !==
                -1 ||
              x.destino.toLowerCase().indexOf(value.toLowerCase()) !== -1
          );
  };

  getById = async (id) => {
    this.showLoading();
    try {
      const result = await Shipment.getById(id);
      if (result.success) this.entity = result.data;
      return Promise.resolve(true);
    } catch (error) {
      this.displayError(error);
      return Promise.resolve(false);
    } finally {
      this.hideLoading();
    }
  };

  getGuide = async (noGuia) => {
    this.showLoading();
    try {
      const result = await Shipment.getGuide(
        noGuia,
        parseInt(process.env.REACT_APP_ID_ORGANIZATION)
      );
      if (result.success) {
        this.entity = result?.data;
        if (result.data) {
          return Promise.resolve(true);
        } else {
          return Promise.reject(false);
        }
      }
    } catch (error) {
      this.displayError(error);
      return Promise.reject(false);
    } finally {
      this.hideLoading();
    }
  };

  downloadGuide = async (id, name) => {
    this.showLoading();
    try {
      await Shipment.downloadGuide(id, name);
    } catch (error) {
      this.displayError(error);
    } finally {
      this.hideLoading();
    }
  };

  getGuideFile = async (id) => {
    this.showLoading();
    try {
      const result = await Shipment.getGuideFile(id);
      return Promise.resolve(result);
    } catch (error) {
      this.displayError(error);
      return Promise.resolve(null);
    } finally {
      this.hideLoading();
    }
  };

  getExcel = async (filter, name) => {
    this.showLoading();
    try {
      await Shipment.exporterExcel(filter, name);
      this.rootStore.alertStore.alertCreateSuccess("Exportado con Éxito");
    } catch (error) {
      this.displayError(error);
    } finally {
      this.hideLoading();
    }
  };

  getExistGuium = async (noGuium, lockGuium = false, isStorageGuide = true) => {
    this.showLoading();
    try {
      var result = await Shipment.getExistGuium(noGuium, lockGuium);
      const guium = result.data;

      debugger;
      if (
        guium &&
        guium.proveedorEstatus === EnumStatusCatalogs.Activo &&
        guium.proveedorEmpresaEstatus === 1
      ) {
        if (guium.idEstatus === EnumStatusShipment.Creado) {
          if (isStorageGuide) {
            if (guium.destinoEstatus !== EnumStatusCatalogs.Activo) {
              let status = "";
              guium.idDestino = undefined;
              for (const key in EnumStatusCatalogs) {
                if (Object.hasOwnProperty.call(EnumStatusCatalogs, key)) {
                  if (guium.destinoEstatus === EnumStatusCatalogs[key]) {
                    status = key.toString();
                  }
                }
              }
              this.rootStore.alertStore.alertError(
                `El destino de este envío se encuentra ${status}, favor de elegir un nuevo destino`
              );
            }
            this.guium = guium;
          }
          return Promise.resolve({ continue: true });
        } else {
          let status = "";
          for (const key in EnumStatusShipment) {
            if (Object.hasOwnProperty.call(EnumStatusShipment, key)) {
              if (guium.idEstatus === EnumStatusShipment[key]) {
                status = key;
              }
            }
          }
          this.rootStore.alertStore.alertError(
            `Este no. de guía no se puede recibir, ya que tiene estatus de ${status}`
          );
        }
      } else {
        this.rootStore.alertStore.alertError("No. de guía no encontrado");
      }
    } catch (error) {
      this.displayError(error);
    } finally {
      this.hideLoading();
    }
  };

  receivedGuium = async (guium) => {
    this.showLoading();
    try {
      const result = await Shipment.receivedGuium(guium);
      const filters = this.getDataFilters(this.filterUsers);
      this.getAll(filters);
      return Promise.resolve(result.data);
    } catch (error) {
      this.displayError(error);
    } finally {
      this.hideLoading();
    }
  };

  updateGuium = async (guium) => {
    this.showLoading();
    try {
      const result = await Shipment.updateGuium(guium);
      this.rootStore.alertStore.alertCreateSuccess(
        "Guía actualizada correctamente"
      );
      const filters = this.getDataFilters(this.filterProviders, true);
      this.getAll(filters);
      return Promise.resolve(result.data);
    } catch (error) {
      this.displayError(error);
    } finally {
      this.hideLoading();
    }
  };

  createdGuium = async (guium) => {
    this.showLoading();
    try {
      const result = await Shipment.createdGuium(guium);
      const filters = this.getDataFilters(this.filterProviders, true);
      this.getAll(filters);
      return Promise.resolve(result.data);
    } catch (error) {
      this.displayError(error);
      return Promise.error();
    } finally {
      this.hideLoading();
    }
  };

  getMovimientosToday = async () => {
    this.showLoading();
    try {
      const result = await Shipment.getMovimientosToday();
      if (result.success) this.entity = result.data;
      return Promise.resolve(result);
    } catch (error) {
      this.displayError(error);
      return Promise.resolve(error);
    } finally {
      this.hideLoading();
    }
  };

  revisonMovimientoUsuario = async (data) => {
    this.showLoading();
    try {
      const result = await Shipment.revisonMovimientoUsuario(data);
      if (result.success) this.entity = result.data;
      return Promise.resolve(result);
    } catch (error) {
      this.displayError(error);
      return Promise.resolve(error);
    } finally {
      this.hideLoading();
    }
  };

  leerAlertasUsuario = async (data) => {
    this.showLoading();
    try {
      const result = await Shipment.leerAlertasUsuario(data);
      if (result.success) this.entity = result.data;
      return Promise.resolve(result);
    } catch (error) {
      this.displayError(error);
      return Promise.resolve(error);
    } finally {
      this.hideLoading();
    }
  };

  cerrarAlertasUsuario = async (data) => {
    this.showLoading();
    try {
      const result = await Shipment.cerrarAlertasUsuario(data);
      if (result.success) this.entity = result.data;
      return Promise.resolve(result);
    } catch (error) {
      this.displayError(error);
      return Promise.resolve(error);
    } finally {
      this.hideLoading();
    }
  };

  consultarEnviosParaEmbarque = async (filter) => {
    this.showLoading();
    try {
      const result = await Shipment.consultarEnviosParaEmbarque(filter);
      return Promise.resolve(result.data);
    } catch (error) {
      this.displayError(error);
      return Promise.resolve(null);
    } finally {
      this.hideLoading();
    }
  };

  bloqueoEnvio = async (bloqueo, data) => {
    this.showLoading();
    try {
      const result = await Shipment.bloqueoEnvio(bloqueo, data);
      return Promise.resolve(result.data);
    } catch (error) {
      this.displayError(error);
      return Promise.resolve(null);
    } finally {
      this.hideLoading();
    }
  };

  notificarEnvioActualizado = async (data) => {
    this.showLoading();
    try {
      const result = await Shipment.notificarEnvioActualizado(data);
      if (result.success) this.entity = result.data;
      return Promise.resolve(result);
    } catch (error) {
      this.displayError(error);
      return Promise.resolve(error);
    } finally {
      this.hideLoading();
    }
  };

  getMovimientosProveedor = async () => {
    this.showLoading();
    try {
      const result = await Shipment.getMovimientosProveedor();
      if (result.success) this.entity = result.data;
      return Promise.resolve(result);
    } catch (error) {
      this.displayError(error);
      return Promise.resolve(error);
    } finally {
      this.hideLoading();
    }
  };

  getEnviosProgramadosRevision = async () => {
    this.showLoading();
    try {
      const result = await Shipment.getEnviosProgramadosRevision();
      if (result.success) this.entity = result.data;
      return Promise.resolve(result);
    } catch (error) {
      this.displayError(error);
      return Promise.resolve(error);
    } finally {
      this.hideLoading();
    }
  };

  revisoEnviosProgramados = async (data) => {
    this.showLoading();
    try {
      const result = await Shipment.revisoEnviosProgramados(data);
      if (result.success) this.entity = result.data;
      return Promise.resolve(result);
    } catch (error) {
      this.displayError(error);
      return Promise.resolve(error);
    } finally {
      this.hideLoading();
    }
  };

  getDataFilters = (filter, isProvider = false) => {
    const data = { ...filter };
    if (data?.fechaInicio && !data?.fechaFin) {
      Object.assign(data, { fechaFin: new Date() });
    }
    if (data?.idProovedor) {
      data.idProovedor = data.idProovedor?.value;
    }
    if (data?.idDestino) {
      data.idDestino = data.idDestino?.value;
    }
    if (data?.idEstatus) {
      data.idEstatus = data.idEstatus?.value;
    }
    if (isProvider) {
      Object.assign(data, { isSearchByUserIdProvider: true });
    }
    Object.assign(data, {
      pageSize: this.pageSize,
      currentPage: this.currentPage,
    });
    return data;
  };

  showLoading = () => {
    this.rootStore.logisticBackdropStore.openLoading();
  };

  hideLoading = () => {
    this.rootStore.logisticBackdropStore.closeLoading();
  };

  displayError = (error) => {
    this.rootStore.alertStore.alertError(getError(error));
  };
}
